module.exports = {
  username: '',
  password: '',
  logedin: false
}
